module.exports = __webpack_public_path__ + "img/trash-icon.f8609233.svg";